import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import DeleteModal from '@components/DeleteModal';
import { toastError, toastSuccess } from '@components/Toast';

import Fabric from '@features/materials/components/Fabric';
import MaterialCardItemView from '@features/materials/components/MaterialCardItemView';
import MaterialInventory from '@features/materials/components/MaterialInventory';
import TrimsAndAccessories from '@features/materials/components/TrimsAndAccessories';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';
import { likeMaterial, unlikeMaterial } from '@store/material/action';

import { fetchSimilarMaterials } from '@services/commonService';

import ApiClient from '@lib/apiClient';

import { enumObj, MATERIAL_TITLE_NAME, VIEW_TYPE_OBJ } from '@utils/MaterialsUtil';
import { getUserInfo } from '@utils/Util';

const MaterialCardContainer = ({ materialType }) => {
	const [materialsData, setMaterialsData] = useState(null);
	const [isInventoryModal, setIsInventoryModal] = useState(false);
	const [viewType, setViewType] = useState('');
	const [isEdit, setIsEdit] = useState('');
	const [selectedMaterials] = useState([]);
	const [selectedItem, setSelectedItem] = useState(null);
	const [remove, setRemove] = useState(false);
	const [defaultViewType] = useState(getUserInfo().systemPreference?.[VIEW_TYPE_OBJ.MATERIAL_LIST.name]);
	const { id } = useParams();
	const dispatch = useDispatch();

	useEffect(() => {
		getSimilarMaterials();
	}, []);

	const getSimilarMaterials = async () => {
		const data = await fetchSimilarMaterials(id);
		setMaterialsData(data);
	};

	const onFabricSubmit = () => {
		getSimilarMaterials();
	};

	const onMaterialClick = (item, materialType) => {
		let url = `/materials/view/${item?.materialId}?type=${materialType}`;
		window.open(url, '_blank');
		// returnnavigate(url);
	};

	const onEdit = (e, item, viewType) => {
		item.id = item.materialId;
		setViewType(viewType);
		setSelectedItem(item);
		setIsEdit(materialType);
		e.stopPropagation();
	};

	const inventoryModalOpen = (e, item) => {
		item.id = item.materialId;
		setSelectedItem(item);
		setIsInventoryModal(true);
		e.stopPropagation();
	};

	const onExpired = async (e, item) => {
		e.stopPropagation();
		dispatch(openLoader());
		await ApiClient.PUT(
			'updatedMaterialByMaterialIdAndIsExpired',
			null,
			item.materialId + '/' + !item?.isExpired
		)
			.then(() => {
				getSimilarMaterials();
				dispatch(closeLoader());
			})
			.catch(({ response }) => {
				dispatch(closeLoader());
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
			});
	};

	const onSetLikeAndUnlike = (id, isLike) => {
		let tempMaterialList = materialsData?.data?.map((item) => {
			if (item.materialId === id) {
				item.liked = isLike;
			}
			return item;
		});
		materialsData.data = tempMaterialList;
		setMaterialsData({ ...materialsData });
	};

	const onLikeMaterial = async (id) => {
		onSetLikeAndUnlike(id, true);
		let response = await dispatch(likeMaterial(id));
		if (!response) {
			onSetLikeAndUnlike(id, false);
		}
	};

	const onUnlikeMaterial = async (id) => {
		onSetLikeAndUnlike(id, false);
		let response = await dispatch(unlikeMaterial(id));
		if (!response) {
			onSetLikeAndUnlike(id, true);
		}
	};

	const onClose = () => {
		setIsEdit(false);
		setIsInventoryModal(false);
		setRemove(false);
	};

	const onRemove = async () => {
		dispatch(openLoader());
		await ApiClient.DELETE('materialAction', {}, selectedItem.materialId)
			.then(({ data }) => {
				if (data && data.success) {
					dispatch(closeLoader());
					toastSuccess(data.message);
					getSimilarMaterials();
					onClose();
				}
			})
			.catch(({ response }) => {
				dispatch(closeLoader());
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
			});
	};

	return (
		<div className="mt-3 bg-white p-4">
			{materialsData && (
				<>
					<span className="mt-3 mb-3 semibold-16">
						Similar{' '}
						{materialType === 'FABRIC'
							? materialType.toLowerCase() + 's'
							: materialType.toLowerCase()}
						: {materialsData?.totalElements}
					</span>
					<div className="fabric-list-container mt-3">
						<MaterialCardItemView
							cardOrigin="SIMILAR"
							materialsData={materialsData}
							activeStep={materialType}
							onMaterialClick={onMaterialClick}
							onEdit={onEdit}
							selectedMaterialIdList={selectedMaterials}
							setSelectedItem={setSelectedItem}
							inventoryModalOpen={inventoryModalOpen}
							onExpired={onExpired}
							setRemove={setRemove}
							defaultViewType={defaultViewType}
							onLikeMaterial={onLikeMaterial}
							onUnlikeMaterial={onUnlikeMaterial}
							cardModelName={'Materials'}
						/>
						{isInventoryModal && (
							<MaterialInventory
								materialData={selectedItem}
								onclose={onClose}
								viewType={'EDIT'}
							/>
						)}
						{isEdit === 'FABRIC' && (
							<Fabric
								materialData={selectedItem}
								isShow={true}
								onclose={onClose}
								onSubmitSuccess={onFabricSubmit}
								viewType={viewType}
								renderFrom={'MATERIAL'}
							/>
						)}

						{isEdit === 'TRIMS' && (
							<TrimsAndAccessories
								isAdd={false}
								materialData={selectedItem}
								title={MATERIAL_TITLE_NAME.TRIMS}
								isShow={true}
								onclose={onClose}
								viewType={viewType}
								renderFrom={enumObj.MATERIAL}
							/>
						)}

						{remove && <DeleteModal onRemove={onRemove} onClose={onClose} />}
					</div>
				</>
			)}
		</div>
	);
};

export default MaterialCardContainer;
